<template>
  <b-container class="bv-example-row pre-signin">
        <h6>Logged in as</h6>
        <h5 style="color: #001f42 !important;"> <strong>{{ agent_username}} </strong></h5>
        <br>
        <b-button variant="outline-secondary" @click="onLogout()"> Logout</b-button>
        <b-button variant="outline-secondary" @click="backToContactsPage()" style="margin-left: 10px; padding:6px 20px ;"> Back </b-button>



    </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import "amazon-connect-streams";
import "amazon-connect-chatjs"
import {logoutAgent} from '../../lib/CallActions'
import store from '../../store';

export default {
  name: 'Profile',
  data() {
    return {

    }
  },
  mounted() {
    

  },
  methods : {
    onLogout(){
      console.log("Logout is clicked")
      logoutAgent()
    },
    disableFrame(){
      console.log("disable frame from profile")
      var payload = {};
      payload.action = "DISABLE_FRAME";
      parent.postMessage(payload,'*');
    },
    backToContactsPage(){
      store.dispatch("common/routePage", "home");

    },
  
    
  },
  computed: {
    ...mapGetters([
      'agent_username',
      'connect_instance'
    ])
  }
}
</script>

<style scoped>

.pre-signin{
  line-height: 1.5;
  height: 200px;
  margin-top:180px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
}


</style>
